export const useErrorHandler = (status) => {
  watch(status, (value) => {
    if (value === 404) {
      showError({ message: 'Page not found', statusCode: value });
    }
  });
};
